import type { SVGProps } from "react";
import { memo } from "react";
const SvgCheveronDown = (props: SVGProps<SVGSVGElement>) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className={`svg-icon ${props.className || ''}`}><path d="M14.001 23.999 16 25.998l16-16-3.999-3.999L16 17.997 3.999 5.999 0 9.998z" /></svg>;
const Memo = memo(SvgCheveronDown);
export default Memo;